"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_DROPDOWN_SORT = exports.DEFAULT_DROPDOWN_TYPE = exports.DEFAULT_TITLE_FONT_SIZE = exports.DEFAULT_SUBTITLE_FONT_SIZE = exports.DEFAULT_HIDE_YEAR = exports.DEFAULT_HIDE_X_TICKS = exports.DEFAULT_HIDE_VALUE_LABEL = exports.DEFAULT_HIDE_TOP_X_TICKS = exports.DEFAULT_HIDE_TOOLTIP_YEAR = exports.DEFAULT_HIDE_TOOLTIP = exports.DEFAULT_HIDE_TITLE = exports.DEFAULT_HIDE_SUBTITLE = exports.DEFAULT_HIDE_LEGEND = exports.DEFAULT_HIDE_GRIDLINES = exports.DEFAULT_HIDE_FOOTER = exports.DEFAULT_HIDE_BOTTOM_X_TICKS = exports.DEFAULT_HIDE_AXIS = exports.DEFAULT_GROUP_SPACING = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_FLOATING_AXIS = exports.DEFAULT_BAR_HEIGHT = void 0;
exports.DEFAULT_BAR_HEIGHT = 30;
exports.DEFAULT_FLOATING_AXIS = false;
exports.DEFAULT_FONT_SIZE = 13;
exports.DEFAULT_GROUP_SPACING = 10;
exports.DEFAULT_HIDE_AXIS = false;
exports.DEFAULT_HIDE_BOTTOM_X_TICKS = false;
exports.DEFAULT_HIDE_FOOTER = false;
exports.DEFAULT_HIDE_GRIDLINES = false;
exports.DEFAULT_HIDE_LEGEND = false;
exports.DEFAULT_HIDE_SUBTITLE = false;
exports.DEFAULT_HIDE_TITLE = false;
exports.DEFAULT_HIDE_TOOLTIP = false;
exports.DEFAULT_HIDE_TOOLTIP_YEAR = false;
exports.DEFAULT_HIDE_TOP_X_TICKS = false;
exports.DEFAULT_HIDE_VALUE_LABEL = false;
exports.DEFAULT_HIDE_X_TICKS = false;
exports.DEFAULT_HIDE_YEAR = false;
exports.DEFAULT_SUBTITLE_FONT_SIZE = 14;
exports.DEFAULT_TITLE_FONT_SIZE = 20;
exports.DEFAULT_DROPDOWN_TYPE = 'items';
exports.DEFAULT_DROPDOWN_SORT = true;